/**
 * Buffer time (ms) to capture audio before the official start time.
 * Prevents clipping at the beginning due to latency.
 */
export const AUDIO_CAPTURE_BUFFER_MS = 3000;
